import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { mergeClassNames } from '../utils/mergeClassNames.es.js';
import { Text, Icon } from '@zapier/design-system';
import React, { useRef } from 'react';
import { useButton } from 'react-aria';
import { Popover as Popover$1, Dialog } from 'react-aria-components';

const popover = "_popover_2ldpy_1";
const popoverContent = "_popover-content_2ldpy_19";
const dialog = "_dialog_2ldpy_35";
const closeButton = "_close-button_2ldpy_39";
const popoverHeaderLayout = "_popover-header-layout_2ldpy_53";
const popoverContentScrollContainer = "_popover-content-scroll-container_2ldpy_61";
const styles = {
	popover: popover,
	popoverContent: popoverContent,
	dialog: dialog,
	closeButton: closeButton,
	popoverHeaderLayout: popoverHeaderLayout,
	popoverContentScrollContainer: popoverContentScrollContainer
};

const Popover = (_a) => {
  var { children, className, color = "dark", onOpenChange, title } = _a, otherProps = __rest(_a, ["children", "className", "color", "onOpenChange", "title"]);
  const ref = useRef(null);
  const { buttonProps } = useButton({ onPress: () => onOpenChange && onOpenChange(false) }, ref);
  return React.createElement(Popover$1, Object.assign({ className: (renderProps) => mergeClassNames([styles.popover, className], renderProps), "data-color": color }, otherProps), (popoverProps) => React.createElement(
    Dialog,
    { className: styles.dialog },
    React.createElement(
      Text,
      { type: "SmallPrint3", color: "GrayWarm1" },
      React.createElement(
        "div",
        { className: styles.popoverHeaderLayout },
        React.createElement(Text, { type: "SmallPrint2", color: color === "dark" ? "BrandLavender" : "UiPrimaryStronger", tag: "div" }, title),
        React.createElement(
          "button",
          Object.assign({ ref }, buttonProps, { className: styles.closeButton, type: "button", "aria-label": "close popover" }),
          React.createElement(Icon, { isBlock: true, name: "formX", size: 16, color: color === "dark" ? "GrayWarm1" : "GrayWarm10" })
        )
      ),
      React.createElement(
        "div",
        { className: styles.popoverContentScrollContainer },
        React.createElement("div", { className: styles.popoverContent, "data-color": color }, typeof children === "function" ? children(popoverProps) : children)
      )
    )
  ));
};

export { Popover };
//# sourceMappingURL=Popover.es.js.map
